
import StepsRequestAccess from "./StepsRequestAccess";
import {REQUEST_ACCESS_STEP_MODEL} from "../Model/Model";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const StepContainerRequestAccess = (props) => {

    const { steps } = props;
    const { renderFindBySelfSteps, renderFindBySelfCreateVisitorSteps, renderIAmNewHereSteps } = StepsRequestAccess(props);

    const renderStepContent = () => {
        switch (steps?.NAME) {
            case REQUEST_ACCESS_STEP_MODEL.FIND_MYSELF.NAME:
                return renderFindBySelfSteps();
            case REQUEST_ACCESS_STEP_MODEL.FIND_MYSELF_CREATE_VISITOR.NAME:
                return renderFindBySelfCreateVisitorSteps();
            case REQUEST_ACCESS_STEP_MODEL.I_AM_NEW_HERE.NAME:
                return renderIAmNewHereSteps();
            default:
                return null;
        }
    };

    return <>{ renderStepContent() }</>;
};

export default StepContainerRequestAccess
